import React from 'react'
import { Text2xl, TextLg } from '../../components/text'

export const NotFound = () => {
  return (
    <div className='h-screen w-[100vw] flex flex-col items-center justify-center text-gray-400'>
      <div className='flex flex-col items-center select-none'>
        <Text2xl className='michroma-regular'>
          404
        </Text2xl>
        <TextLg className='michroma-regular'>
          Not Found
        </TextLg>
      </div>
    </div>
  )
}
